import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a1152a3")

_pushScopeId("data-v-1a1152a3")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Leverage adjustment")
const _hoisted_2 = { class: "content df-col df-middle pb-32" }
const _hoisted_3 = { class: "px-16" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "home_41" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    controls: _withId(() => [
      _createVNode(_component_Button, {
        class: "flex-1 btn",
        onClick: _ctx.handleClose,
        progress: _ctx.closeLoading
      }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            path: "home_43",
            args: {current: _ctx.curLever},
            custom: ""
          }, {
            default: _withId(({td}) => [
              _createTextVNode(_toDisplayString(td || 'No, stay moderate '), 1)
            ]),
            _: 1
          }, 8, ["args"])
        ]),
        _: 1
      }, 8, ["onClick", "progress"]),
      _createVNode(_component_Button, {
        class: "flex-1 btn primary",
        onClick: _ctx.handleDetail,
        progress: _ctx.okLoading
      }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            path: "home_44",
            custom: ""
          }, {
            default: _withId(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Yes, see details'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick", "progress"])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Pic, {
          src: "home/confirmation",
          width: "88",
          height: "88"
        }),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_t, {
            as: "div",
            path: "home_42",
            args: {current: _ctx.curLever},
            multiline: "",
            custom: ""
          }, {
            default: _withId(({td}) => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(td, (p, index) => {
                return (_openBlock(), _createBlock("p", {
                  class: {'f-bold my-8': index===1},
                  key: index
                }, _toDisplayString(p), 3))
              }), 128))
            ]),
            _: 1
          }, 8, ["args"])
        ])
      ])
    ]),
    _: 1
  }))
})